var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgDropdownSearch = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.51891 1.6C6.27746 1.6 7.01898 1.83782 7.64969 2.28339C8.2804 2.72896 8.77198 3.36226 9.06226 4.10322C9.35255 4.84417 9.4285 5.6595 9.28051 6.44609C9.13253 7.23268 8.76725 7.95521 8.23088 8.52232C7.6945 9.08942 7.01111 9.47562 6.26714 9.63208C5.52316 9.78855 4.75201 9.70824 4.0512 9.40133C3.3504 9.09442 2.7514 8.57468 2.32998 7.90784C1.90855 7.24099 1.68361 6.457 1.68361 5.655C1.68361 4.57955 2.08769 3.54814 2.80695 2.78768C3.5262 2.02722 4.50173 1.6 5.51891 1.6ZM5.51891 0C4.19196 0.000135534 2.91239 0.521501 1.92853 1.46291C0.944674 2.40431 0.32671 3.69861 0.194578 5.0946C0.0624453 6.49058 0.425569 7.88869 1.21347 9.01755C2.00137 10.1464 3.15786 10.9255 4.45846 11.2037C5.75907 11.4818 7.11103 11.2392 8.25195 10.5228C9.39287 9.80643 10.2414 8.66745 10.6328 7.32691C11.0242 5.98637 10.9306 4.53989 10.3701 3.26822C9.80963 1.99654 8.8223 0.990377 7.59971 0.445C6.94116 0.151315 6.23365 8.0397e-06 5.51891 0Z",
    fill: "#9FABCC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.07342 7.994L8 9.12891L11.8128 13.1601L12.8862 12.0252L9.07342 7.994Z",
    fill: "#9FABCC"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDropdownSearch, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/dropdown-search.e5ee7102.svg";
export { ForwardRef as ReactComponent };